// services/paramsApi.js
import api from './api'

// Frontend API wrapper for params
export async function fetchParams() {
  const { data } = await api.get('/prerolls-ext/params')
  return data // { dinamici: {...}, statici: {...} }
}

export async function saveParams({ dinamici, statici }) {
  const { data } = await api.post('/prerolls-ext/params', { dinamici, statici })
  return data // { success, urlDin, urlSta }
}